<template>
  <vs-col
      class="p-0"
      vs-align="center"
      vs-justify="flex-end"
      vs-type="flex"
      vs-w="2.8"
  >
    <SideBar
        :active="modalServicosAgenda"
        :title="'Editar Agenda: ' + endereco.nome"
        :visualizar="!buttonStatus"
        size="huger"
        :textSucces="validacao == true ? 'Salvar' : 'Validar'"
        @hide="modalServicosAgenda = false"
        @success="validacao == true ? submitForm() : verificarAgenda()"
    >
      <div
          id="editarAgenda"
          slot="body"
          class="w-full p-4 vs-con-loading__container"
      >
        <vs-col vs-w="5">
          <div class="w-full">
            <vs-col vs-type="flex" vs-w="12">
              <Agenda class="m-4"></Agenda>
            </vs-col>
            <vs-col
              vs-w="12"
              vs-type="flex"
              vs-align="center"
              vs-justify="center"
            >
              <vs-button
                color="warning"
                :disabled="!($atividades && $atividades.permissoes && $atividades.permissoes.includes(12))"
                @click="submitForm()"
                type="relief"
              >Salvar Sem Bloqueios</vs-button>
            </vs-col>
          </div>
        </vs-col>
        <vs-col vs-w="7">
          <vs-divider border-style="dotted">Data dos serviços</vs-divider>
          <div id="head_modal_agenda" class="vs-con-loading__container">
            <VuePerfectScrollbar
                :settings="settings"
                class="scroll-servicos-editar-agenda"
            >
              <div v-for="(servico, index) in servicos" :key="index" class="mb-4 pb-2 item-servico-editar">
                <vs-row
                    vs-align="center"
                    vs-justify="flex-start"
                    vs-type="flex"
                    vs-w="12"
                >
                  <vs-col vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <vs-input
                          v-model="servicos[index].data_servico"
                          :label="`OS Nº${servico.id}`"
                          color="dark"
                          disabled
                          style="width: 140px"
                          type="date"
                      />
                    </div>
                  </vs-col>
                  <vs-col
                      vs-type="flex"
                      vs-w="3"
                  >
                    <div v-if="servico.executado < 1" class="w-full mx-1">
                      <vs-input
                          :key="key"
                          v-model="servicos[index].data_remarcacao_servico"
                          v-validate="'required'"
                          :name="'os' + index"
                          color="dark"
                          label="Data Remarcação"
                          style="width: 140px"
                          type="date"
                          @change="onDataChange(index)"
                      />
                    </div>
                    <label v-else class="font-bold" size="small"
                    >OS com retorno!</label
                    >
                  </vs-col>
                  <vs-col v-if="servico.executado < 1" vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <div style="display: flex !important; align-items: center; justify-content: space-between; width: 140px;">
                        <label style="color: black; font-size: 0.85rem;">
                          {{ servicos[index].agendarPorTurno ? 'Turno' : 'Hora Marcada' }}
                        </label>
                        <vs-switch v-model="servicos[index].agendarPorTurno" @input="toggleAgendamento(index)">
                          <span slot="on"></span>
                          <span slot="off"></span>
                        </vs-switch>
                      </div>
                      <div v-if="servicos[index].agendarPorTurno">
                        <el-select
                            v-model="servicos[index].id_turno"
                            v-validate="'required'"
                            :name="'turno' + index"
                            :popper-append-to-body="false"
                            clearable
                            filterable
                            placeholder="Selecione..."
                            style="width: 140px"
                            @change="removeValidacaoIndex(index)"
                        >
                          <el-option
                              v-for="turno in turnos"
                              :key="turno.id"
                              :label="turno.nome"
                              :value="turno.id"
                          ></el-option>
                        </el-select>
                      </div>
                      <div v-else>
                        <vs-input
                            v-model="servicos[index].hora_marcada"
                            v-mask="'##:00'"
                            v-validate="'required'"
                            :name="'horario' + index"
                            class="inputx"
                            max="24"
                            placeholder="00:00"
                            style="width: 140px"
                            type="datetime"
                            @change="removeValidacaoIndex(index)"
                        />
                      </div>
                    </div>
                  </vs-col>
                  <vs-col v-if="servico.executado < 1" vs-type="flex" vs-w="3">
                    <div class="w-full mx-1">
                      <label style="color: black; font-size: 0.85rem"
                      >Prioridade</label
                      >
                      <br/>
                      <el-select
                          v-model="servicos[index].id_nivel_prioridade"
                          v-validate="false"
                          :name="'prioridade' + index"
                          :popper-append-to-body="false"
                          clearable
                          filterable
                          placeholder="Selecione..."
                          style="width: 140px"
                      >
                        <el-option
                            v-for="nivel in nivel_prioridade"
                            :key="nivel.id"
                            :label="nivel.nome"
                            :value="nivel.id"
                        ></el-option>
                      </el-select>
                    </div>
                  </vs-col>
                </vs-row>

                <div v-if="servico.executado < 1" class="status-badge-wrapper date-badge-inline mt-2 ml-1">
                  <div v-if="!servico.statusValidacao" class="status-badge badge-aguardando">
                    <i class="material-icons badge-icon">hourglass_empty</i>
                    <span class="badge-text">Aguardando validação</span>
                  </div>
                  <div v-else-if="servico.statusValidacao === 'indisponivel'" class="status-badge badge-indisponivel">
                    <i class="material-icons badge-icon">close</i>
                    <span class="badge-text">Não há disponibilidade</span>
                    <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        type="button"
                        @click.stop="abrirHistorico(index)"
                    >
                      <i class="material-icons" style="font-size: 13px;">history</i>
                      Dias
                    </button>
                  </div>
                  <div v-else-if="servico.statusValidacao === 'proximo'" class="status-badge badge-proximo">
                    <i class="material-icons badge-icon">warning</i>
                    <span class="badge-text">Data mais próxima: {{ servico.dataProxima }}</span>
                    <button
                        v-if="servico.historicoFalhas && servico.historicoFalhas.length > 0"
                        class="badge-history-btn"
                        type="button"
                        @click.stop="abrirHistorico(index)"
                    >
                      <i class="material-icons" style="font-size: 13px;">history</i>
                      Dias
                    </button>
                  </div>
                  <div v-else-if="servico.statusValidacao === 'disponivel'" class="status-badge badge-disponivel">
                    <i class="material-icons badge-icon">check_circle</i>
                    <span class="badge-text">Disponível</span>
                  </div>
                </div>
              </div>
            </VuePerfectScrollbar>
          </div>
          <div class="w-full mt-3">
            <vs-row
                vs-align="center"
                vs-justify="start"
                vs-type="flex"
                vs-w="12"
            >
              <vs-col vs-type="flex" vs-w="10">
                <div class="w-full mx-2">
                  <vs-textarea
                      v-model="obsRemarcacao"
                      v-validate="'required'"
                      class="w-full"
                      color="dark"
                      label="Motivo da alteração"
                      name="obs"
                  />
                </div>
              </vs-col>
            </vs-row>
          </div>
        </vs-col>
      </div>
    </SideBar>

    <ModalHistoricoBuscaForca
      :ativo.sync="popupHistoricoAtivo"
      :historico="servicoHistoricoSelecionado ? servicoHistoricoSelecionado.historicoFalhas || [] : []"
      :data-selecionada="servicoHistoricoSelecionado ? servicoHistoricoSelecionado.data_remarcacao_servico : null"
      :disponivel="servicoHistoricoSelecionado ? servicoHistoricoSelecionado.disponivel : null"
    />
  </vs-col>
</template>
<script>
import components from "@/components/default/exports.js";
import Agenda from "../../../agenda/Agenda.vue";
import ModalHistoricoBuscaForca from "./modalHistoricoBuscaForca.vue";

export default {
  props: {
    cliente: {require: true},
    contrato: {require: true},
    endereco: {nome: "Carregando", servicos: 0},
    servicoEndereco: null,
  },
  data() {
    return {
      key: 0,
      buttonStatus: true,
      modalServicosAgenda: false,
      validacao: false,
      popupHistoricoAtivo: false,
      servicoHistoricoSelecionado: null,
      diaSelect: [1, 2, 3, 4, 5, 6, 7],
      turnos: [
        {id: 1, nome: "Manha"},
        {id: 2, nome: "Almoco"},
        {id: 3, nome: "Tarde"},
        {id: 4, nome: "Noite"},
        {id: 5, nome: "Madrugada"},
      ],
      nivel_prioridade: [
        {id: 1, nome: "Baixa"},
        {id: 2, nome: "Média"},
        {id: 3, nome: "Alta"}
      ],
      servicos: [],
      settings: {
        maxScrollbarLength: 200,
        wheelSpeed: 0.6,
        height: 1000,
      },
      obsRemarcacao: "",
    };
  },
  methods: {
    formatarData(data) {
      if (!data) return "";
      const parts = data.split("-");
      return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : data;
    },
    abrirHistorico(index) {
      this.servicoHistoricoSelecionado = this.servicos[index];
      this.popupHistoricoAtivo = true;
    },
    removeValidacaoIndex(index) {
      this.validacao = false;
      this.$set(this.servicos[index], "statusValidacao", null);
      this.$set(this.servicos[index], "dataProxima", null);
      this.$set(this.servicos[index], "historicoFalhas", []);
      this.$set(this.servicos[index], "disponivel", null);
    },
    onDataChange(index) {
      this.key++;
      this.removeValidacaoIndex(index);
    },
    toggleAgendamento(index) {
      this.removeValidacaoIndex(index);
    },
    async submitForm() {
      // eslint-disable-next-line no-unused-vars
      return new Promise((resolve, reject) => {
        this.$validator.validateAll().then((result) => {
          if (result) {
            this.reagendarServicos();
          } else {
            this.$vs.notify({
              title: "Preencha todos os campos",
              text: "Os campos não devem ser vazios!",
              color: "danger",
            });
          }
        });
      });
    },
    async verificarAgenda() {
      this.buttonStatus = false;
      const result = await this.$validator.validateAll();
      if (!result) {
        this.$vs.notify({
          title: "Preencha todos os campos",
          text: "Os campos não devem ser vazios!",
          color: "danger",
        });
        this.buttonStatus = true;
        return;
      }

      const servicosEditaveis = this.servicos.filter(s => s.executado < 1);
      if (servicosEditaveis.length === 0) {
        this.$vs.notify({
          title: "Atenção",
          text: "Não há serviços disponíveis para reagendar.",
          color: "warning",
        });
        this.buttonStatus = true;
        return;
      }

      this.validacao = null;
      await this.$vs.loading({
        container: "#head_modal_agenda",
        scale: 0.9,
      });

      let date = this.$formartData.dataHoje();
      let todasDisponiveis = true;
      let temProximo = false;
      let primeiroHistoricoComFalha = null;

      for (let i = 0; i < this.servicos.length; i++) {
        const servico = this.servicos[i];
        if (servico.executado >= 1) continue;

        const isTurnoValido = servico.agendarPorTurno && servico.id_turno !== null && servico.id_turno !== "";
        const isHoraMarcadaValida = !servico.agendarPorTurno && servico.hora_marcada !== null && servico.hora_marcada !== "";

        if (!isTurnoValido && !isHoraMarcadaValida) {
          todasDisponiveis = false;
          this.$set(servico, "statusValidacao", "indisponivel");
          continue;
        }

        const dataOriginal = servico.data_remarcacao_servico;
        const isInicial = servico.id_tipo == 1 || servico.id_tipo == 3;
        const horasExec = servico.horas_exec || (isInicial ? this.contrato.horas_iniciais : this.contrato.horas_manutencao);
        const tecsExec = servico.tecnicos_exec || (isInicial ? this.contrato.tecnicos_iniciais : this.contrato.tecnicos_manutencao);
        const carros = parseInt(servico.carros != null ? servico.carros : this.contrato.carros) || 0;

        const datasUsadas = this.servicos
          .filter((s, idx) => idx !== i && s.disponivel == 1)
          .map(s => ({ data: s.data_remarcacao_servico, disponivel: 1 }));

        try {
          const resService = await this.$http.post("verificarForca", {
            data: servico.data_remarcacao_servico,
            id_turno: servico.agendarPorTurno ? servico.id_turno : null,
            horaMarcada: !servico.agendarPorTurno ? servico.hora_marcada : null,
            horas_exec: horasExec,
            tecnicos_exec: tecsExec,
            dias: this.diaSelect,
            inicial: isInicial,
            carros: carros,
            hoje: date,
            periodoManutencao: this.contrato.periodo_manutencao,
            datas: datasUsadas,
          });

          this.$set(servico, "status", resService.status);
          this.$set(servico, "disponivel", resService.disponivel);
          this.$set(servico, "historicoFalhas", resService.historicoFalhas || []);

          if (resService.disponivel == 1) {
            if (resService.data === dataOriginal) {
              this.$set(servico, "statusValidacao", "disponivel");
            } else {
              this.$set(servico, "statusValidacao", "proximo");
              this.$set(servico, "dataProxima", this.formatarData(resService.data));
              temProximo = true;
            }
            this.$set(servico, "data_remarcacao_servico", resService.data);
            this.$set(servico, "color", "success");
          } else {
            servico.ultimaData = resService.data;
            this.$set(servico, "statusValidacao", "indisponivel");
            this.$set(servico, "color", "danger");
            todasDisponiveis = false;
          }

          if (!primeiroHistoricoComFalha && resService.historicoFalhas && resService.historicoFalhas.length > 0) {
            primeiroHistoricoComFalha = servico;
          }
        } catch (err) {
          todasDisponiveis = false;
          this.$set(servico, "statusValidacao", "indisponivel");
          const error = this.$httpErrors(err);
          this.$vs.notify(error);
          if (error.code == 401) {
            await window.localStorage.clear();
            await this.$router.push("/");
          }
        }
      }

      this.key++;
      await this.$vs.loading.close("#head_modal_agenda > .con-vs-loading");
      this.buttonStatus = true;

      if (primeiroHistoricoComFalha) {
        this.servicoHistoricoSelecionado = primeiroHistoricoComFalha;
        this.popupHistoricoAtivo = true;
      }

      if (todasDisponiveis) {
        this.validacao = true;
        if (temProximo) {
          this.$vs.notify({
            title: "Atenção",
            text: "Algumas datas foram ajustadas para os dias disponíveis mais próximos.",
            color: "warning",
          });
        } else {
          this.$vs.notify({
            title: "Sucesso",
            text: "Todas as datas e turnos estão disponíveis!",
            color: "success",
          });
        }
      } else {
        this.validacao = false;
        this.$vs.notify({
          title: "Indisponibilidade",
          text: "Existem serviços com datas ou turnos indisponíveis. Verifique o histórico de disponibilidade.",
          color: "danger",
        });
      }
    },
    async reagendarServicos() {
      await this.$vs.loading({
        container: "#editarAgenda",
        scale: 0.6,
      });
      
      let servicosParaEnviar = JSON.parse(JSON.stringify(this.servicos));
      for (let x of servicosParaEnviar) {
        if (x.agendarPorTurno) x.hora_marcada = null;
        else x.id_turno = null;
      }
      
      try {
        await this.$http.post("editarAgenda", {
          servicos: servicosParaEnviar,
          contrato: this.contrato,
          endereco: this.endereco,
          obs: this.obsRemarcacao,
        });
        await this.$emit("update");
        this.modalServicosAgenda = false;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#editarAgenda > .con-vs-loading");
      }
    },
    async getServicosEndereco() {
      await this.$vs.loading({
        container: "#editarAgenda",
        scale: 0.6,
      });
      try {
        const res = await this.$http.post("getServicosEndereco", {
          id_endereco: this.endereco.id_endereco,
          id_contrato: this.contrato.id,
        });
        this.servicos = res.servicos;

        for (let x of this.servicos) {
          x.data_remarcacao_servico = x.data_servico;
          x.statusValidacao = null;
          x.dataProxima = null;
          x.historicoFalhas = [];
          x.disponivel = null;

          if (x.id_turno) {
            x.id_turno = Number(x.id_turno);
          }
          
          const hasHora = x.hora_marcada && x.hora_marcada !== "00:00:00" && x.hora_marcada !== "00:00";
          
          if (hasHora) {
            this.$set(x, "agendarPorTurno", false);
          } else {
            this.$set(x, "agendarPorTurno", true);
          }
        }

        this.validacao = false;
        this.popupHistoricoAtivo = false;
        this.servicoHistoricoSelecionado = null;
        this.key++;
      } catch (err) {
        const error = this.$httpErrors(err);
        this.$vs.notify(error);
        if (error.code == 401) {
          await window.localStorage.clear();
          await this.$router.push("/");
        }
      } finally {
        await this.$vs.loading.close("#editarAgenda > .con-vs-loading");
      }
    },
  },
  async mounted() {
    this.modalServicosAgenda = true;
    await this.getServicosEndereco();
  },
  components: {...components, Agenda, ModalHistoricoBuscaForca},
};
</script>
<style lang="scss">
.scroll-servicos-editar-agenda {
  max-height: 50vh !important;
}
.item-servico-editar {
  border-bottom: 1px dashed #e2e8f0;
}
.status-badge-wrapper {
  display: flex;
  align-items: center;
  margin-top: 18px;
}
.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.badge-icon {
  font-size: 16px !important;
}
.badge-text {
  font-size: 12px;
}
.badge-aguardando {
  background-color: #fef3c7;
  color: #78350f;
}
.badge-indisponivel {
  background-color: #fee2e2;
  color: #7f1d1d;
}
.badge-proximo {
  background-color: #fed7aa;
  color: #7c2d12;
}
.badge-disponivel {
  background-color: #bbf7d0;
  color: #14532d;
}
.badge-history-btn {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  margin-left: 6px;
  padding: 2px 8px;
  border: none;
  border-radius: 12px;
  background: rgba(0,0,0,0.15);
  color: inherit;
  font-size: 11px;
  cursor: pointer;
  white-space: nowrap;
  font-family: inherit;
}
.badge-history-btn:hover {
  background: rgba(0,0,0,0.25);
}
.date-with-badge {
  display: flex;
  align-items: flex-end;
  gap: 12px;
}
.date-badge-inline {
  flex-shrink: 0;
  margin-top: 0;
  padding-bottom: 4px;
}
</style>
